import {
  GET_TODO_CATEGORY_SUCCESS,
  GET_TODO_CATEGORY_FAILURE,
  GET_TODO_CATEGORY_REQUEST,
  ADD_TODO_CATEGORY_SUCCESS,
  ADD_TODO_CATEGORY_FAILURE,
  ADD_TODO_CATEGORY_REQUEST,
  DELETE_TODO_CATEGORY_SUCCESS,
  DELETE_TODO_CATEGORY_FAILURE,
  DELETE_TODO_CATEGORY_REQUEST,
  UPDATE_TODO_CATEGORY_SUCCESS,
  FAILURE,
  REQUEST
} from '../types/todo'

const initialState = {
  todos: [],
  error: false,
  errorStatus: '',
  loading: false
}

export default (state = initialState, action) => {
  switch (action.type) {
    case GET_TODO_CATEGORY_SUCCESS:
      return Object.assign({}, state, {
        todos: action.value,
        loading: false
      })
    case GET_TODO_CATEGORY_REQUEST:
      return Object.assign({}, state, {
        loading: true
      })
    case GET_TODO_CATEGORY_FAILURE:
      return Object.assign({}, state, {
        loading: false,
        error: true,
        errorStatus: action.value
      })
    case ADD_TODO_CATEGORY_SUCCESS:
      return Object.assign({}, state, {
        loading: false,
        error: false,
        errorStatus: '',
        todos: [...state.todos, action.value]
      })
    case ADD_TODO_CATEGORY_REQUEST:
      return Object.assign({}, state, {
        loading: true
      })
    case ADD_TODO_CATEGORY_FAILURE:
      return Object.assign({}, state, {
        loading: false,
        error: true,
        errorStatus: action.value
      })
    case DELETE_TODO_CATEGORY_SUCCESS:
      // action.value = id de l'objet à delete
      const newTodos = [...state.todos].filter(
        (todo) => todo._id != action.value
      )
      return Object.assign({}, state, {
        loading: false,
        error: false,
        errorStatus: '',
        todos: newTodos
      })
    case DELETE_TODO_CATEGORY_REQUEST:
      return Object.assign({}, state, {
        loading: true
      })
    case DELETE_TODO_CATEGORY_FAILURE:
      return Object.assign({}, state, {
        loading: false,
        error: true,
        errorStatus: action.value
      })
    case UPDATE_TODO_CATEGORY_SUCCESS:
      // action.value => nouveau doc
      let todosCopy = [...state.todos]
      for (let todo in todosCopy) {
        if (todosCopy[todo]._id == action.value._id) {
          todosCopy[todo] = action.value
        }
      }
      return Object.assign({}, state, {
        loading: false,
        error: false,
        errorStatus: '',
        todos: todosCopy
      })
    case REQUEST:
      return Object.assign({}, state, {
        loading: true
      })
    case FAILURE:
      return Object.assign({}, state, {
        loading: false,
        error: true,
        errorStatus: action.value
      })
    default:
      return state
  }
}
